import React from 'react';
import GameWindowHeader from "../InGameUI/GameWindowHeader";
import GameWindowBg from "../InGameUI/GameWindowBg";
import GameButtonWithText from "../InGameUI/GameButtonWithText";
import './ListView.css'

export default class ListView extends React.Component {
    render() {
        const content = <div className={"select__content"}>
            <div className={"select__games"}>
                {this.props.children}
            </div>
            <GameButtonWithText disabled={this.props.disabled} width={250} height={40} title={"Выбрать"}
                                onClick={this.props.onSelect}/>
        </div>;

        return <div className="select__window">
            <GameWindowHeader width={300} height={40} title={"Выберите игру"} isClosable={!!this.props.onHide} onHide={this.props.onHide}/>
            <GameWindowBg width={300} height={380} value={content}/>
        </div>;
    }
}
